<template>
  <div class="flex">
    <router-link
      v-if="to && theme !== 'disabled'"
      :to="to"
      :class="classObject"
      tag="button"
    >
      {{ title }}
    </router-link>
    <a
      v-else-if="href"
      :href="href"
      :class="classObject"
      class="text-center"
    >
      {{ title }}
    </a>
    <button
      v-else
      :class="classObject"
      :disabled="theme === 'disabled'"
    >
      {{ title }}
    </button>
  </div>
</template>

<script>
import { concat } from 'lodash';

export default {

  name: 'BaseButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      validator(value) {
        return ['primary', 'secondary', 'outlined', 'black', 'disabled'].indexOf(value) !== -1;
      },
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
    fixedBottom: {
      type: Boolean,
      default: false,
    },
    notRounded: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    padded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObject() {
      let mainClasses = ['text-lg', 'outline-none'];
      if (this.padded) {
        mainClasses = concat(mainClasses, ['px-4']);
      } else {
        mainClasses = concat(mainClasses, ['flex-1']);
      }
      if (this.theme === 'secondary') {
        return concat(mainClasses, ['text-grey']);
      }
      mainClasses = concat(mainClasses, ['py-4', 'font-heavy', 'md:px-8']);
      if (this.fixedBottom) {
        mainClasses = concat(mainClasses, ['fixed', 'pin-b', 'pin-l', 'w-screen', 'rounded-none']);
      } else if (!this.notRounded) {
        mainClasses = concat(mainClasses, ['rounded']);
      }
      if (this.theme === 'outlined') {
        return concat(mainClasses, ['text-orange', 'border', 'border-grey-lighter', 'font-sans-medium']);
      }
      if (this.theme === 'black') {
        return concat(mainClasses, ['text-white', 'bg-black']);
      }
      if (this.theme === 'disabled') {
        return concat(mainClasses, ['text-white', 'bg-orange-light', 'opacity-20', 'cursor-not-allowed']);
      }
      return concat(mainClasses, ['text-white', 'bg-orange-light', 'hover:bg-orange-dark']);
    },
  },
};
</script>
